<template>
  <div class="projectRule">
    <el-form
      ref="projectRuleRef"
      :model="form"
      label-width="180px"
      class="form projectRule_form"
      :rules="projectRules"
    >
      <el-card class="box-card projectRulecard">
        <div slot="header" class="clearfix">
          <span>项目随机抽取规则</span>
        </div>
        <span class="redtipText">注：根据已抽取的项目抽取规则填写即可</span>
        <div v-if="canEditpage">
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目所属监管单位：" prop="superviseDeptCode" style="width:100%;">
                <!-- :disabled="disabledFlag" -->
                <!-- <el-select
                  :popper-append-to-body="false"
                  clearable
                  filterable
                  multiple
                  style="width:100%;"
                  v-model="form.superviseDeptCode"
                  value-key="id"
                 
                >
                  <el-checkbox
                    :indeterminate="form.superviseDeptCode&&form.superviseDeptCode.length !== orgSelectList.length"
                    @change="selectAll"
                    class="bidScreenCheckBox"
                    v-model="superviseDeptCodeAll"
                  >全选</el-checkbox>
                  <el-option
                    :key="index"
                    :label="item.name"
                    :value="item.deptCode"
                    v-for="(item,index) in orgSelectList"
                  ></el-option>
                </el-select> -->
                <select-depart-tree 
                    :selectAllBtn="true"
                    ref="selectDepartTreeRef"
                    :modelValue.sync="form.superviseDeptCode"  
                    :isMultiple="true" 
                    @handleDeptType="(val)=>changeDept(val,'5')" >
                </select-depart-tree>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目名称包含：" prop="projectName" style="width:100%;">
                <!-- :disabled="disabledFlag" -->
                <el-input v-model="form.projectName" maxlength="200" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目招标人名称包含：" prop="tendererName" style="width:100%;">
                <!-- :disabled="disabledFlag" -->
                <el-input v-model="form.tendererName" maxlength="100" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目招标代理名称包含：" prop="tenderAgencyName" style="width:100%;">
                <!--  :disabled="disabledFlag"-->
                <el-input v-model="form.tenderAgencyName" maxlength="100" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="招标公告发布时间：" prop="noticePubTimes" style="width:100%;">
                <!-- :disabled="disabledFlag" popper-class="blueTime"  -->
                <el-date-picker
                  style="width:100%;"
                  v-model="form.noticePubTimes"
                  :picker-options="pickerOptions"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目合同签署时间：" prop="contractSignTimes" style="width:100%;">
                <!-- :disabled="disabledFlag" -->
                <el-date-picker
                  style="width:100%;"
                  v-model="form.contractSignTimes"
                  :picker-options="pickerOptions"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="抽取数量组成方式：" prop="ruleType" style="width:100%;">
                <el-radio :label="1" v-model="form.ruleType">数量</el-radio>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item
                label="抽取数量："
                prop="extractNum"
                :error="extractNumError"
                style="width:100%;"
              >
                从符合条件的总数中随机抽取
                <el-input-number
                  style="width: 100px;margin-right:20px;"
                  v-model="form.extractNum"
                  controls-position="right"
                  :min="0"
                  :max="100"
                  @change="changeNumber"
                ></el-input-number>
                <span
                  class="el-input-icon el-input-slot"
                  :class="{'el-input-icon-ie':isIEBrowser()}"
                >个</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-if="!canEditpage">
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目所属监管单位：" prop="superviseDeptCode" style="width:100%;">
                <span>{{form.superviseDeptCodeName}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="项目名称包含：" prop="projectName" style="width:100%;">
                <span>{{form.projectName|| "-"}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目招标人名称包含：" prop="tendererName" style="width:100%;">
                <span>{{form.tendererName || "-"}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目招标代理名称包含：" prop="tenderAgencyName" style="width:100%;">
                <span>{{form.tenderAgencyName || "-"}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="招标公告发布时间：" style="width:100%;">
                <span>{{form.noticePubTimesNoEdit || "-"}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="项目合同签署时间：" style="width:100%;">
                <span>{{form.contractSignTimesNoEdit || "-"}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="抽取数量组成方式：" prop="ruleType" style="width:100%;">
                <el-radio-group v-model="form.ruleType" disabled>
                  <el-radio :label="1">数量</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="form.ruleType == 1 || form.ruleType == 2">
              <el-form-item label="抽取数量：" prop="extractNum" style="width:100%;">
                <span>从符合条件的总数中随机抽取</span>
                <span>{{form.extractNum + ' ' + (form.ruleType == 1?'个':' %')}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import moment from "moment";
import selectDepartTree from "@/views/modules/components/selectDepartTree"
export default {
  props: {
    formData: {
      type: Object,
      default: () => {}
    },
    filterDeptList:{
      type:Array,
      default: () => []
    }
  },
  components:{
    selectDepartTree
  },
  data() {
    return {
      canEditpage: true,
      orgSelectList: [],
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() >
            new Date(moment().format("yyyy-MM-DD") + " 23:59:59").getTime()
          );
        }
      },
      noticePubTimes: [],
      noticePubTimes1: [],
      form: {
        projectName: "",
        tendererName: "",
        superviseDeptCode: [],
        tenderAgencyName: "",
        noticePubTimes: "",
        noticePubTimes: "",
        contractSignTimes: "",
        ruleType: "",
        extractNum: "",
       

      },
      projectRules: {
        superviseDeptCode: [
          {
            required: true,
            message: "请选择项目所属监管单位",
            trigger: ["blur", "change"]
          }
        ],
        // projectName: [
        //   { required: true, message: "请输入项目名称包含", trigger: "blur" }
        // ],
        // tendererName: [
        //   { required: true, message: "请输入项目招标人名称包含：", trigger: "blur" }
        // ],
        // tenderAgencyName: [
        //   { required: true, message: "请输入项目招标代理名称包含：", trigger: "blur" }
        // ],
        // noticePubTimes: [
        //   { required: true, message: "请选择招标公告发布时间：", trigger: "blur" }
        // ],
        // contractSignTimes: [
        //   { required: true, message: "请选择项目合同签署时间", trigger: "blur" }
        // ],
        ruleType: [
          { required: true, message: "请选择抽取数量组成方式", trigger: "blur" }
        ],
        extractNum: [
          { required: true, message: "请选择抽取数量", trigger: "blur" }
        ]
      },
      errorData: {}
    };
  },
  watch: {
    formData: {
      deep: true,
      immediate: true,
      handler(newV, oldV) {
        this.form = JSON.parse(JSON.stringify(newV));
        this.canEditpage = this.form.canEdit;

        setTimeout(() => {
          this.$refs.projectRuleRef?this.$refs.projectRuleRef.clearValidate(["superviseDeptCode"]):'';
        }, 500);
        // 回显项目行
        this.changeNumber(newV.extractNum);
      }
    },
    form:{
      deep: true,
      immediate: true,
      handler(newV, oldV) {
     this.$emit("changeProjectFormMethods",newV)
      }
    },
    orgSelectList:{
      deep: true,
      immediate: true,
      handler(val){
        this.$emit('update:filterDeptList',  val)
      }
    }
  },
  mounted() {
    this.getOrgSelectList();
    setTimeout(() => {
      this.$refs.projectRuleRef?this.$refs.projectRuleRef.clearValidate(["superviseDeptCode"]):'';
    }, 300);
  },
  computed: {
    superviseDeptCodeAll: {
      get() {
        return (
          this.form.superviseDeptCode &&
          this.form.superviseDeptCode.length === this.orgSelectList.length
        );
      },
      set() {}
    },
    extractNumError: function() {
      return this.errorData.extractNum;
    }
  },
  methods: {
    changeDept(val,flag){
        // falg==5 表示多选
        this.form.superviseDeptCode=[]
        val.forEach((element)=>{
            if( element.type!=="region"&&(!element.children)){
            this.form.superviseDeptCode.push(element.code)
            }
        })
    },
    validate(callback) {
      //这个form是子组件内部
      this.$refs.projectRuleRef.validate(valid => {
        callback(valid);
      });
    },
    getOrgSelectList() {
      this.$httpReq
        .get("/projectDoubleExtract/extracttask/getDepartments")
        .then(res => {
          if (res.data.code == "1") {
            let resData = res.data.data || [];
            let dataArr = [];
            resData.forEach(item => {
              dataArr.push(item.data);
            });
            this.orgSelectList = dataArr;
            return;
          }
        });
    },
    selectAll(checked) {
      if (checked) {
        this.form.superviseDeptCode = this.orgSelectList.map(d => d.deptCode);
      } else {
        this.form.superviseDeptCode = [];
      }
    },
    changeNumber(val) {
      this.$emit("changeProjectNumber", val);
    }
  }
};
</script>
  <style lang="scss" scoped>
.bidScreenCheckBox {
  margin-left: 20px;
}
.projectRulecard {
  position: relative;
  .redtipText {
    position: absolute;
    left: 180px;
    top: 30px;
    color: red;
    font-size: 12px;
  }
}
</style>